// src/modules/app-views/_apps/appmulti/quotations/List/QuotationsFilter.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { memo } from 'react';
import { Col, Collapse, Row, Select } from 'antd';
import translateX from 'utils/translateX';
import appmultiService from 'modules/app-views/_apps/appmulti/services/appmultiService';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import { DEFAULT_BACK_COLOR, DEFAULT_BACK_COLOR_DARK } from 'constants/Constants';
import useZustand from 'hooks/useZustand';

// *******************************************************************************
// COMPONENT
// *******************************************************************************
const QuotationsFilter = memo(props => {
  const storedCurrentTheme = useZustand('theme', 'currentTheme');
  const bgColor = storedCurrentTheme === 'dark' ? DEFAULT_BACK_COLOR_DARK : DEFAULT_BACK_COLOR;

  const {
    dataListing,
    classification,
    setClassification,
    openFilter,
    setOpenFilter,
    setFilteredData,
    travelProfile,
    setTravelProfile,
    operator,
    setOperator,
  } = props;

  // RENDER HELPERS
  const travelProfileOptions = appmultiService.getTravelProfiles();
  const operatorsOptions = appmultiService.getOperatorsFromPlans(dataListing);

  // HANDLERS
  const onChangeClassification = value => {
    const list = appmultiService.sorterPlans(dataListing, {
      classification: value,
      profile: travelProfile,
      operator,
    });
    setFilteredData(list);
    setClassification(value);
  };

  const onChangeTravelProfile = value => {
    const list = appmultiService.sorterPlans(dataListing, {
      classification,
      profile: value,
      operator,
    });
    setFilteredData(list);
    setTravelProfile(value);
  };

  const onChangeOperator = value => {
    const list = appmultiService.sorterPlans(dataListing, {
      classification,
      profile: travelProfile,
      operator: value,
    });
    setFilteredData(list);
    setOperator(value);
  };

  // RENDER
  const filterItems = buildFilter();

  return (
    <div className="quotations-filter-wrapper" style={{ backgroundColor: bgColor }}>
      <Collapse
        defaultActiveKey={openFilter ? 'additional_fields' : null}
        size="large"
        ghost
        items={filterItems}
        className="no-collapse-padding"
        onChange={() => setOpenFilter(!openFilter)}
      />
    </div>
  );

  function buildFilter() {
    return [
      {
        key: 'additional_fields',
        label: <span className="text-uppercase text-muted">{translateX('filter_data')}</span>,
        children: (
          <Row gutter={ROW_GUTTER}>
            <Col xs={24} sm={8}>
              <Select
                className="mb-3 w-100"
                size="large"
                allowClear
                placeholder="Operadora"
                optionFilterProp="children"
                value={operator}
                onChange={onChangeOperator}
                options={operatorsOptions || []}
              />
            </Col>
            <Col xs={24} sm={8}>
              <Select
                className="mb-3 w-100"
                allowClear
                size="large"
                placeholder="Tipo de Viagem"
                optionFilterProp="children"
                value={travelProfile}
                onChange={onChangeTravelProfile}
                options={travelProfileOptions || []}
              />
            </Col>
            <Col xs={24} sm={8}>
              <Select
                className="mb-3 w-100"
                size="large"
                placeholder={translateX('classification')}
                optionFilterProp="children"
                value={classification}
                onChange={onChangeClassification}
                options={[
                  { value: 'best_seller', label: translateX('best_seller') },
                  { value: 'cheaper', label: translateX('cheaper') },
                  { value: 'more_expansive', label: translateX('more_expansive') },
                ]}
              />
            </Col>
          </Row>
        ),
      },
    ];
  }
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default QuotationsFilter;
